import _ from 'lodash';

import agencyService from './services/agency.service';
import subAgencyService from './services/sub-agency.service';

export const GET_AGENCIES = 'agency/GET_AGENCIES';
export const GET_AGENCY = 'agency/GET_AGENCY';
export const UPDATE_AGENCY = 'agency/UPDATE_AGENCY';

export const GET_SUB_AGENCIES = 'agency/GET_SUB_AGENCIES';
export const CREATE_SUB_AGENCY = 'agency/CREATE_SUB_AGENCY';

export const GET_AGENTS = 'agency/GET_AGENTS';

const initialState = {
  currentAgency: null,
  agencies: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_AGENCIES: {
      const agencies = action.payload;
      return {
        ...state,
        agencies,
      };
    }
    case GET_AGENCY: {
      return {
        ...state,
        currentAgency: action.payload
      };
    }
    case UPDATE_AGENCY: {
      const agency = action.payload;
      const agencies = state.agencies.slice();
      let currentAgency = state.currentAgency;
      const index = agencies.findIndex(({id}) => id === agency.id);

      if (index > -1) {
        agencies[index] = agency;
      }

      if (currentAgency && (currentAgency.id === agency.id)) {
        currentAgency = agency;
      }
      
      return {
        ...state,
        currentAgency,
        agencies,
      };
    }
    case GET_SUB_AGENCIES: {
      const {agencyId, subAgencies} = action.payload;
      const agencies = state.agencies.slice();
      const agency = state.agencies.find(({id}) => id === agencyId);
      const currentAgency = state.currentAgency;

      if (agency) {
        agency.subAgencies = subAgencies;

        if (currentAgency && currentAgency.id === agencyId) {
          currentAgency.subAgencies = subAgencies;
        }
      }

      return {
        ...state,
        currentAgency,
        agencies
      }
    }
    case CREATE_SUB_AGENCY: {
      const {agencyId, subAgency} = action.payload;
      const agencies = state.agencies;
      const agency = agencies.find(({id}) => id === agencyId);
      let currentAgency = state.currentAgency;

      if (agency) {
        agency.subAgencies = agency.subAgencies || [];
        agency.subAgencies.push(subAgency);

        if (currentAgency.id === agencyId) {
          currentAgency = agency;
        }
      }

      return {
        ...state,
        currentAgency,
        agencies
      }
    }
    default:
      return state;
  }
}

export const getAgencies = () => {
  return (dispatch) => {
    return agencyService.getAgencies()
      .then((res) => {
        const groupedSubAgencies = _.groupBy(res, 'agencyId');
        
        // agencies which dont have agencyId are parent agencies
        const agencyObjs = groupedSubAgencies.undefined || [];
        delete groupedSubAgencies.undefined;
        
        agencyObjs.forEach((agency) => {
          const {id} = agency;
          agency.subAgencies = groupedSubAgencies[id] || [] 
        });

        dispatch({
          type: GET_AGENCIES,
          payload: agencyObjs
        });
        return agencyObjs;
      });
  };
};

export const loadAgency = (id) => {
  return (dispatch, getState) => {
    return agencyService.getAgency(id)
      .then((agency) => {
        dispatch({
          type: GET_AGENCY,
          payload: agency
        });

        if (agency && agency.id) {
          getSubAgencies(agency.id)(dispatch, getState);
        }

        return agency;
      });
  };
};

export const updateAgency = (id, data) => {
  return (dispatch, getState) => {
    return agencyService.updateAgency(id, data)
    .then((agency) => {
      dispatch({
        type: UPDATE_AGENCY,
        payload: agency
      });
      return agency;
    });
  };
};

export const getAgentsForAgency = () => {
  return (dispatch, getState) => {
    const currentAgency = getState().agency.currentAgency;
    return agencyService.getAgentsForAgency(currentAgency.id)
      .then((agents) => {
        dispatch({
          type: GET_AGENTS,
          payload: {
            agents,
          }
        });
        return agents;
      })
  };
};

export const  getSubAgencies = (agencyId) => {
  return (dispatch, getState) => {

    if (!agencyId) {
      const currentAgency = getState().agency.currentAgency;
      
      if (!currentAgency) {
        const auth = getState().auth;
        
        if (auth && auth.user) {
          return loadAgency(auth.user.agencyId)(dispatch, getState);
        }
        else {
          return Promise.resolve();
        }
      }
      else {
        agencyId = currentAgency.id;
      }
    }
		
    return subAgencyService.getSubAgencies(agencyId)
      .then((subAgencies) => {
        dispatch({
          type: GET_SUB_AGENCIES,
          payload: {
            agencyId,
            subAgencies
          }
        });

        return subAgencies;
      });
  };
};

export const createSubAgency = (agencyId, subAgencyData) => {
  return (dispatch, getState) => {
    const agencyId = getState().agency.currentAgency.id;
    return subAgencyService.createSubAgency(agencyId, subAgencyData)
      .then((subAgency) => {
        dispatch({
          type: CREATE_SUB_AGENCY,
          payload: {
            agencyId,
            subAgency
          }
        });
        return subAgency;
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/agency.js